// plugins/helder/shop/assets/ts/FilterMenu.ts

export class FilterMenu {

    private readonly form: HTMLFormElement;
    private debounceTimer: number | null = null;
    private readonly DEBOUNCE_MS = 800;

    constructor(formElement: HTMLFormElement) {
        this.form = formElement;
        this.bindEvents();
    }

    private bindEvents(): void {

        this.form.addEventListener('input', () => this.scheduleRequest());

        const selects = this.form.querySelectorAll<HTMLSelectElement>('[data-hldr-select-filters]');
        selects.forEach(select => {

            // @ts-ignore
            if (typeof window.$ !== 'undefined') {
                // @ts-ignore
                window.$(select).on('change', () => this.scheduleRequest());
            }
        });

        this.form.addEventListener('submit', (e: SubmitEvent) => {
            e.preventDefault();
            this.scheduleRequest();
        });
    }

    /**
     * Debounce the input to prevent spamming the server
     */
    private scheduleRequest(): void {
        if (this.debounceTimer !== null) {
            window.clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = window.setTimeout(() => {
            this.fireRequest();
        }, this.DEBOUNCE_MS);
    }

    /**
     * Executes the AJAX request using October's native API
     */
    private fireRequest(): void {
        const urlParams = new URLSearchParams(window.location.search);
        const currentPage = urlParams.get('page') || '1';

        // @ts-ignore
        if (typeof window.oc !== 'undefined' && window.oc.request) {
            // @ts-ignore
            window.oc.request(this.form, 'onFilter', {
                data: {page: currentPage},
                flash: true
            });
        } else {
            console.error('October CMS AJAX framework (LaraJax) is not loaded.');
        }
    }
}

// Initialization
document.addEventListener('DOMContentLoaded', () => {
    const filterForms = document.querySelectorAll('[data-hldr-shop-filter-menu]') as NodeListOf<HTMLFormElement> | null;

    if (!filterForms) return;

    for (const filterForm of filterForms) {
        new FilterMenu(filterForm);
    }
});